module.exports = __webpack_public_path__ + "img/icon_map_108_off_100.3ab9b676.png";